export const InputField = ({
  label,
  name,
  value,
  placeholder,
  onChange,
  type = "text",
  className = "",
  required = false,
  maxLength,
  disabled = false,
}: any) => (
  <div>
    <label className="block text-sm font-medium text-gray-700 mb-1 tracking-wide">
      {label}
    </label>
    <input
      type={type}
      name={name}
      placeholder={placeholder}
      value={
        type === "date" && value
          ? new Date(value).toISOString().slice(0, 10)
          : value || ""
      }
      onChange={onChange}
      required={required}
      maxLength={maxLength}
      disabled={disabled}
      className={`w-full px-3 py-2 border border-gray-300 bg-gray-50 rounded-md shadow-sm 
        focus:outline-none focus:ring-2 focus:ring-blue-500 
        transition duration-200 ease-in-out hover:border-gray-400 ${className}`}
    />
  </div>
);

export const SelectField = ({ label, name, value, options, onChange }: any) => {
  const normalizedValue = value?.toLowerCase().replace(/\s+/g, "_") || "";

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1 tracking-wide">
        {label}
      </label>
      <select
        name={name}
        value={normalizedValue}
        onChange={onChange}
        className="w-full px-3 py-2 border border-gray-300 bg-gray-50 rounded-md shadow-sm 
          focus:outline-none focus:ring-2 focus:ring-blue-500 
          transition duration-200 ease-in-out hover:border-gray-400"
      >
        <option value="">Select</option>
        {options.map((opt: string) => (
          <option key={opt} value={opt.toLowerCase().replace(/\s+/g, "_")}>
            {opt}
          </option>
        ))}
      </select>
    </div>
  );
};
